(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfort-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Nombres y descripción de cada tecnología.
    var TECH = {
      cloudfoam: { name: 'Cloudfoam', brand: 'adidas', desc: 'Espuma suave para todo el día' },
      bounce: { name: 'Bounce', brand: 'adidas', desc: 'Respuesta dinámica y estabilidad' },
      boost: { name: 'Boost', brand: 'adidas', desc: 'El mayor retorno de energía' },
      softfoam: { name: 'SoftFoam+', brand: 'Puma', desc: 'Plantilla acolchada para el día a día' }
    };

    // EDITA AQUÍ la tabla de resultados: uso → sensación → { p: principal, a: alternativa, why }.
    var MATRIX = {
      diario: {
        suave: { p: 'cloudfoam', a: 'softfoam', why: 'Buscas suavidad para caminar o estar de pie muchas horas.' },
        rebote: { p: 'boost', a: 'bounce', why: 'Quieres comodidad diaria con una pisada más viva.' },
        firme: { p: 'bounce', a: 'cloudfoam', why: 'Prefieres un pie bien sostenido durante todo el día.' }
      },
      gym: {
        suave: { p: 'softfoam', a: 'cloudfoam', why: 'Entrenas ligero y quieres una plantilla acolchada.' },
        rebote: { p: 'bounce', a: 'boost', why: 'Buscas respuesta en saltos y cambios de dirección.' },
        firme: { p: 'bounce', a: 'softfoam', why: 'Necesitas estabilidad para entrenar.' }
      },
      correr: {
        suave: { p: 'boost', a: 'bounce', why: 'Corres y quieres amortiguación con buen retorno de energía.' },
        rebote: { p: 'boost', a: 'bounce', why: 'Corres y buscas el máximo rebote.' },
        firme: { p: 'bounce', a: 'boost', why: 'Corres y prefieres una pisada más estable.' }
      }
    };

    var USO_LABEL = { diario: 'Todo el día', gym: 'Gym', correr: 'Correr' };
    var SENS_LABEL = { suave: 'Suave', rebote: 'Con rebote', firme: 'Firme' };

    function norm(s) {
      var str = String(s == null ? '' : s).replace(',', '.');
      var m = str.match(/\d+(?:\.\d+)?/);
      return m ? m[0] : str.trim().toLowerCase();
    }

    function techKey(s) {
      return String(s || '').toLowerCase().replace(/[^a-z]/g, '');
    }

    function track(name, data) {
      var payload = data || {};
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('sportland:comfort_finder_' + name, payload);
        }
      } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        var evt = { event: 'comfort_finder_' + name };
        Object.keys(payload).forEach(function (k) { evt[k] = payload[k]; });
        window.dataLayer.push(evt);
      } catch (e) {}
    }

    function el(tag, props, kids) {
      var n = document.createElement(tag);
      if (props) {
        Object.keys(props).forEach(function (k) {
          var v = props[k];
          if (v == null || v === false) return;
          if (k === 'text') n.textContent = v;
          else if (k === 'class') n.className = v;
          else n.setAttribute(k, v === true ? '' : String(v));
        });
      }
      (kids || []).forEach(function (c) {
        if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
      return n;
    }

    function setCartAttribute(label) {
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Comfort Finder': label } }),
          keepalive: true
        });
      } catch (e) {}
    }

    function init(root) {
      if (!root || root.getAttribute('data-cf-ready') === '1') return;
      root.setAttribute('data-cf-ready', '1');

      var data = { settings: {}, products: [] };
      try { data = JSON.parse(root.querySelector('[data-cf-data]').textContent); } catch (e) {}
      var cfg = data.settings || {};
      var products = (data.products || []).map(function (p) {
        return {
          t: techKey(p.t),
          title: p.title,
          url: p.url,
          price: p.price,
          img: p.img,
          amz: p.amz,
          sizes: (p.sizes || []).map(function (x) { return { s: norm(x.s), v: x.v }; })
        };
      });

      var state = { step: 1, uso: null, sens: null, size: null, started: false };
      var steps = root.querySelectorAll('[data-cf-step]');
      var segs = root.querySelectorAll('[data-cf-seg]');
      var stepLabel = root.querySelector('[data-cf-step-label]');
      var progress = root.querySelector('[data-cf-progress]');
      var backBtn = root.querySelector('[data-cf-back]');
      var resultBox = root.querySelector('[data-cf-result]');

      function show(step) {
        state.step = step;
        Array.prototype.forEach.call(steps, function (s) {
          s.hidden = s.getAttribute('data-cf-step') !== String(step);
        });
        var inQuiz = step < 4;
        progress.hidden = !inQuiz;
        backBtn.hidden = !(step > 1 && step < 4);
        if (inQuiz) {
          stepLabel.textContent = 'Paso ' + step + ' de 3';
          Array.prototype.forEach.call(segs, function (sg, i) {
            sg.setAttribute('data-state', i + 1 < step ? 'done' : (i + 1 === step ? 'current' : 'todo'));
          });
        }
        if (state.started) {
          var target = root.querySelector('[data-cf-step="' + step + '"] [data-cf-focus]');
          if (target) target.focus();
        }
      }

      function inSize(key) {
        return products.filter(function (p) {
          return p.t === key && p.sizes.some(function (x) { return x.s === state.size; });
        });
      }

      function amazonFor(key) {
        if (cfg.amazon && cfg.amazon[key]) return cfg.amazon[key];
        var withAmz = products.filter(function (p) { return p.t === key && p.amz; })[0];
        return withAmz ? withAmz.amz : '';
      }

      function productCard(p, key) {
        var t = TECH[key];
        var match = p.sizes.filter(function (x) { return x.s === state.size; })[0];
        var href = p.url;
        if (match && match.v) href += (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + match.v;

        var media = el('span', { class: 'cf__prod-media' }, [
          p.img
            ? el('img', { src: p.img, alt: t.brand + ' ' + p.title, loading: 'lazy', width: '96', height: '72' })
            : el('span', { class: 'cf__prod-line', text: 'Sin foto' })
        ]);
        var card = el('a', { class: 'cf__prod', href: href, 'data-testid': 'cf-result-product' }, [
          media,
          el('span', { class: 'cf__prod-info' }, [
            el('span', { class: 'cf__prod-line', text: t.brand + ' ' + t.name }),
            el('span', { class: 'cf__prod-title', text: p.title }),
            el('span', { class: 'cf__prod-price', text: p.price })
          ])
        ]);
        card.addEventListener('click', function () {
          track('click_product', { tecnologia: key, producto: p.title, talla: state.size });
          setCartAttribute(t.name + ' · talla ' + state.size);
        });
        return card;
      }

      function renderResult() {
        var rule = (MATRIX[state.uso] || {})[state.sens] || MATRIX.diario.suave;
        var P = TECH[rule.p];
        var A = TECH[rule.a];
        var primaryMatch = inSize(rule.p);
        var altMatch = primaryMatch.length ? [] : inSize(rule.a);
        var usedKey = primaryMatch.length ? rule.p : rule.a;
        var list = (primaryMatch.length ? primaryMatch : altMatch).slice(0, cfg.max || 3);
        var stock = primaryMatch.length ? 'principal' : (altMatch.length ? 'alternativa' : 'sin_stock');

        var kids = [];

        kids.push(el('div', { class: 'cf__chips' }, [
          el('span', { class: 'cf__chip', text: USO_LABEL[state.uso] || '' }),
          el('span', { class: 'cf__chip', text: SENS_LABEL[state.sens] || '' }),
          el('span', { class: 'cf__chip', text: 'Talla ' + state.size }),
          el('button', { type: 'button', class: 'cf__textbtn', 'data-cf-restart': true, 'data-testid': 'cf-change', text: 'Cambiar' })
        ]));

        kids.push(el('div', { class: 'cf__tech', 'data-testid': 'cf-result-tech', 'data-tech': rule.p }, [
          el('span', { class: 'cf__tech-kicker', text: 'Tu tecnología' }),
          el('h3', { class: 'cf__tech-name', tabindex: '-1', 'data-cf-result-focus': true }, [
            P.name + ' ',
            el('span', { class: 'cf__tech-brand', text: P.brand })
          ]),
          el('p', { class: 'cf__tech-why', text: rule.why })
        ]));

        if (stock === 'principal') {
          kids.push(el('p', { class: 'cf__status', text: primaryMatch.length + (primaryMatch.length === 1 ? ' modelo' : ' modelos') + ' en talla ' + state.size }));
        } else if (stock === 'alternativa') {
          kids.push(el('div', { class: 'cf__notice', 'data-testid': 'cf-alt-notice' }, [
            el('p', { class: 'cf__notice-title', text: 'No tenemos ' + P.name + ' en talla ' + state.size + ' ahora' }),
            el('p', { class: 'cf__notice-text', text: 'Lo más parecido que sí tenemos: ' + A.name + ' de ' + A.brand + '. ' + A.desc + '.' })
          ]));
        }

        if (list.length) {
          kids.push(el('div', { class: 'cf__list' }, list.map(function (p) { return productCard(p, usedKey); })));
          if (cfg.links && cfg.links[usedKey]) {
            kids.push(el('a', { class: 'cf__btn', href: cfg.links[usedKey], 'data-testid': 'cf-see-more', text: 'Ver más ' + TECH[usedKey].name }));
          }
        } else {
          var msg = 'Hola, busco tenis ' + P.name + ' en talla ' + state.size + '. ¿Me avisan cuando llegue?';
          var wa = cfg.wa ? 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(msg) : '';
          var amz = amazonFor(rule.p);
          var noStock = [
            el('div', { class: 'cf__notice' }, [
              el('p', { class: 'cf__notice-title', text: 'No tenemos tu talla en ' + P.name + ' ni en ' + A.name + ' ahora' }),
              el('p', { class: 'cf__notice-text', text: 'Te avisamos cuando llegue' + (amz ? ', o puedes verlo ya en Amazon.' : '.') })
            ])
          ];
          if (wa) {
            var waLink = el('a', { class: 'cf__btn', href: wa, target: '_blank', rel: 'noopener', 'data-testid': 'cf-whatsapp', text: 'Avísame por WhatsApp' });
            waLink.addEventListener('click', function () { track('click_whatsapp', { tecnologia: rule.p, talla: state.size }); });
            noStock.push(waLink);
          }
          if (amz) {
            var amzLink = el('a', { class: 'cf__btn cf__btn--ghost', href: amz, target: '_blank', rel: 'sponsored noopener', 'data-testid': 'cf-amazon', text: 'Ver ' + P.name + ' en Amazon' });
            amzLink.addEventListener('click', function () { track('click_amazon', { tecnologia: rule.p, talla: state.size }); });
            noStock.push(amzLink);
          }
          kids.push(el('div', { class: 'cf__res', 'data-testid': 'cf-nostock' }, noStock));
        }

        var foot = [];
        var alreadyLinked = list.length && usedKey === rule.p;
        if (cfg.links && cfg.links[rule.p] && !alreadyLinked) {
          foot.push(el('a', { class: 'cf__link', href: cfg.links[rule.p], text: 'Conoce ' + P.name }));
        } else {
          foot.push(el('span'));
        }
        foot.push(el('button', { type: 'button', class: 'cf__textbtn', 'data-cf-restart': true, 'data-testid': 'cf-restart', text: 'Empezar de nuevo' }));
        kids.push(el('div', { class: 'cf__foot' }, foot));

        resultBox.innerHTML = '';
        resultBox.appendChild(el('div', { class: 'cf__res' }, kids));

        track('result', {
          uso: state.uso, sensacion: state.sens, talla: state.size,
          tecnologia: rule.p, alternativa: rule.a, stock: stock, modelos: list.length
        });
      }

      root.addEventListener('click', function (ev) {
        var pick = ev.target.closest('[data-cf-pick]');
        if (pick && root.contains(pick)) {
          var kind = pick.getAttribute('data-cf-pick');
          var value = pick.getAttribute('data-cf-value');
          if (!state.started) { state.started = true; track('start', {}); }
          Array.prototype.forEach.call(root.querySelectorAll('[data-cf-pick="' + kind + '"]'), function (b) {
            b.setAttribute('aria-pressed', b === pick ? 'true' : 'false');
          });
          if (kind === 'uso') {
            state.uso = value; track('step', { paso: 1, uso: value }); show(2);
          } else if (kind === 'sens') {
            state.sens = value; track('step', { paso: 2, sensacion: value }); show(3);
          } else if (kind === 'size') {
            state.size = norm(value); track('step', { paso: 3, talla: state.size });
            renderResult(); show(4);
            var h = root.querySelector('[data-cf-result-focus]');
            if (h) h.focus();
          }
          return;
        }
        if (ev.target.closest('[data-cf-back]')) { show(Math.max(1, state.step - 1)); return; }
        if (ev.target.closest('[data-cf-restart]')) { show(1); }
      });

      show(1);
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-comfort-finder]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Editor de temas: re-inicializa cuando la sección se recarga.
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
